// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 2V3H18V2H20V3H21V5H20.2198L20.8198 8H22V10H21V20H22V22H2V20H3V10H2V8H3.1802L3.7802 5H3V3H4V2H6ZM19 10H16V20H19V10ZM14 20V10H10V20H14ZM8 20V10H5V20H8Z"}}]};

const ArchwayFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'archway-filled',
    ref,
    icon: element,
  },
));

ArchwayFilledIcon.displayName = 'ArchwayFilledIcon';

export default ArchwayFilledIcon;
